import React from 'react';
import { css } from '@emotion/react';
import { legacyOnly, newDesignOnly } from 'constants/themes.constants';
import styled from 'types/theme.types';
import { SwitcherContainer } from 'components/layout/topbar/switcher/switcher-container';
import { FormattedMessage } from 'react-intl';
import { Link } from 'react-router';
import useStores from 'hooks/use-stores.hooks';

const UserSwitcher: React.FunctionComponent = () => {
  const { authStore } = useStores();
  return (
    <SwitcherContainer>
      <Link to="/personal-settings">
        <MenuItem>
          <FormattedMessage id="personal.settings.menu.personal-settings" />
        </MenuItem>
      </Link>
      <MenuItem onClick={() => authStore.logout()} data-e2e="logout-link">
        <FormattedMessage id="navigation.logout" />
      </MenuItem>
    </SwitcherContainer>
  );
};

const MenuItem = styled.div`
  cursor: pointer;
  padding: 14px 18px;
  font-size: 13px;
  display: flex;
  align-items: center;
  ${legacyOnly(
    theme => css`
      color: ${theme.primaryBlack} !important;
      background: ${theme.primaryWhite};
    `
  )}
  ${newDesignOnly(css`
    color: var(--text-heading);
    background: var(--surface-main-cards);
  `)}

  &:hover {
    ${legacyOnly(
      theme => css`
        background: ${theme.menuGray};
      `
    )}
    ${newDesignOnly(css`
      background: var(--surface-main-element-on-card);
    `)}
  }
`;

export default UserSwitcher;
